import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type ReportsGeneratingPlaceholderProps = {
  className?: string;
  /** Shown while a section is still being produced. */
  message?: string;
};

export function ReportsGeneratingPlaceholder({
  className,
  message = 'PRATUS AI is generating content...',
}: ReportsGeneratingPlaceholderProps) {
  return (
    <div
      className={cn(
        'tw:flex tw:flex-col tw:gap-2 tw:py-2 tw:text-foreground',
        className
      )}
      role="status"
      aria-live="polite"
      aria-label={message.replace(/\.\.\.$/, '')}
    >
      <p className="tw:mb-1 tw:text-sm tw:text-muted-foreground">{message}</p>
      <Skeleton className="tw:h-3 tw:w-full" />
      <Skeleton className="tw:h-3 tw:w-5/6" />
      <Skeleton className="tw:h-3 tw:w-2/3" />
      <Skeleton className="tw:h-3 tw:w-3/4" />
    </div>
  );
}
